export const formatDate = (value) => {
  try {
    if (!value) return ''
    const d = new Date(value)
    return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })
  } catch {
    return ''
  }
}

export const formatDateTime = (value) => {
  try {
    if (!value) return ''
    const d = new Date(value)
    return d.toLocaleString(undefined, {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    })
  } catch {
    return ''
  }
}


